import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-115">
      <div className="max-w-4xl mx-auto space-y-3" data-id="element-116">
        <p className="text-brand-cream font-black text-lg" data-id="element-117">
          🏠 SISTEMA DOMOTICA E SMART HOME PRO
        </p>
        <p className="text-gray-400 font-bold" data-id="element-118">
          Risorse d'eccellenza per la Formazione Tecnica Italiana.
        </p>
        <p className="text-gray-500 italic" data-id="element-119">
          Perché insegnare domotica e automazione non dovrebbe toglierti i tuoi
          momenti di relax.
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 pt-2" data-id="element-120">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-121">
            📧 kitonline27@gmail.com
          </a>
        </div>
        <p className="pt-2" data-id="element-122">
          © Sistema Domotica e Smart Home Pro 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}